module.exports = __webpack_public_path__ + "static/2-978931d354fdcff30c24e9c86638c2d6.jpg";